import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Button,
  Typography,
} from "@mui/material";
import { WarningAmberRounded } from "@mui/icons-material";

/**
 * Shown when the first D1 search enhancement goes from all-off to one-on.
 * Any enhancement switches D1 to rulebook mode on the backend: it steers how
 * the agent searches but is never quoted or cited, so answers must come from
 * D3 documents or Knowledge Graph datasets.
 */
const Dim1RulebookConfirmDialog = ({
  open,
  isDarkMode,
  hasAnswerSource,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle
        sx={{
          fontFamily: '"Poppins", sans-serif',
          fontWeight: 600,
          display: "flex",
          alignItems: "center",
          gap: 1,
          borderBottom: "1px solid",
          borderColor: "divider",
          backgroundColor: isDarkMode
            ? "rgba(255,255,255,0.02)"
            : "rgba(0,0,0,0.02)",
        }}
      >
        <WarningAmberRounded sx={{ color: "#f59e0b" }} />
        D1 will stop answering questions
      </DialogTitle>

      <DialogContent sx={{ pt: "20px !important" }}>
        <Box sx={{ display: "grid", gap: 1.5 }}>
          <Typography
            variant="body2"
            sx={{
              fontFamily: '"Poppins", sans-serif',
              color: isDarkMode ? "#d1d5db" : "#374151",
              lineHeight: 1.7,
            }}
          >
            With this option on, D1 is used only as instructions for how to
            research, and it will no longer be quoted or cited.
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontFamily: '"Poppins", sans-serif',
              lineHeight: 1.7,
              ...(hasAnswerSource
                ? { color: isDarkMode ? "#d1d5db" : "#374151" }
                : { color: "warning.main", fontWeight: 600 }),
            }}
          >
            {hasAnswerSource
              ? "Make sure this agent has D3 documents or a dataset attached, or it will reply that no evidence was found."
              : "This agent has no D3 documents or dataset, so it will not be able to answer questions from its knowledge base."}
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
        <Button
          onClick={onClose}
          sx={{ fontFamily: '"Poppins", sans-serif', fontWeight: 600 }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          sx={{
            fontFamily: '"Poppins", sans-serif',
            fontWeight: 700,
            backgroundColor: "#e36250",
            color: "#ffffff",
            "&:hover": { backgroundColor: "#d14e3c" },
          }}
        >
          Turn on
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Dim1RulebookConfirmDialog;
